const PASSWORD_RECOVERY_COMPLETED_EMAIL_KEY = "weight-tracker-password-recovery-completed-email";

export function getCompletedPasswordRecoveryEmail(): string | null {
  if (typeof window === "undefined") return null;

  const email = window.sessionStorage.getItem(PASSWORD_RECOVERY_COMPLETED_EMAIL_KEY);
  if (!email) return null;
  return email;
}

export function setCompletedPasswordRecoveryEmail(email: string | null): void {
  if (typeof window === "undefined") return;

  if (!email) {
    window.sessionStorage.removeItem(PASSWORD_RECOVERY_COMPLETED_EMAIL_KEY);
    return;
  }

  window.sessionStorage.setItem(PASSWORD_RECOVERY_COMPLETED_EMAIL_KEY, email);
}

export function clearCompletedPasswordRecoveryEmail(): void {
  if (typeof window === "undefined") return;
  window.sessionStorage.removeItem(PASSWORD_RECOVERY_COMPLETED_EMAIL_KEY);
}
